var map = {
	"./de-AT/messages.mjs": [
		73544,
		1081
	],
	"./de-CH/messages.mjs": [
		36134,
		5380
	],
	"./de-DE/messages.mjs": [
		49233,
		5215
	],
	"./fr-BE/messages.mjs": [
		9209,
		789
	],
	"./fr-CH/messages.mjs": [
		61650,
		5151
	],
	"./fr-FR/messages.mjs": [
		36727,
		1722
	],
	"./it-IT/messages.mjs": [
		16178,
		909
	],
	"./nl-BE/messages.mjs": [
		4669,
		5012
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 40453;
module.exports = webpackAsyncContext;